import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../config/settings'
import { actualizarDatosParaMuiTable } from '../actions/TablaBuquesActions'
import { TablaBuquesView } from '../components/TablaBuquesView'

function TablaBuques (props) {
  useEffect(() => {
    props.actualizarDatosParaMuiTable()
  }, [props])

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <TablaBuquesView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaBuques)
